// SHER-1015 / SHER-977: the medical-record entry points that leave the current view.
// Kept out of patient/index.jsx so the routing and gating can be tested on their own.

import { HOSPITAL_PATIENT_TESTS } from '../../../routes/urls';
import { FUNCTIONALITY } from '../../../constants/types';
import { PERMISSION } from '../../../components/investigation/share/user_roles';
import { TYPE_DISCHARGE_SURVEY } from '../../../constants';

// The :typeTest segment for the patient's surgery requests inside the medical record.
// Pedro chose the in-record view over a filtered standalone surgical list (SHER-1015, 2026-09-29).
export const PATIENT_SURGERY_LIST_SECTION = 'surgery';

export function patientSurgeryListUrl(uuidPatient: string): string {
    return HOSPITAL_PATIENT_TESTS.replace(':uuidPatient', uuidPatient)
        .replace(':typeTest', PATIENT_SURGERY_LIST_SECTION);
}

// Same gate as the standalone surgical list: the permission to read it and the module being on.
export function canViewPatientSurgeryList(permissions?: string[], functionalities?: string[]): boolean {
    return Boolean(permissions?.includes(PERMISSION.VISUALIZE_SURGERY)
        && functionalities?.includes(FUNCTIONALITY.SURGERY));
}

// The bed-icon popup confirms the discharge instant, but the write happens one route later, when
// the discharge survey is submitted. The page remounts on that navigation, so the instant travels
// in the history state and is read back only for the discharge survey.
export function dischargeDateOutForSurvey(locationState: unknown, surveyType?: number | string): string | null {
    if (surveyType !== TYPE_DISCHARGE_SURVEY) {
        return null;
    }
    const value = (locationState as { dischargeDateOut?: unknown } | null | undefined)?.dischargeDateOut;
    return typeof value === 'string' ? value : null;
}
